export const development = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
export const apiBaseUrl = development ? "http://localhost:8080" : "https://api.optikergewinnspiel.de";